export default __webpack_public_path__ + "static/media/MozzarellaSticks.661cb98d.jpg";